/**
 * Installation code examples for different languages
 */
export const installationCode = {
    python: `pip install specific_ai`,
    typescript: `npm install specific-ai`,
    go: `go get github.com/marketplace-specificai/go-specific-ai-sdk@latest`
};

/**
 * SpecificAI code examples.
 *
 * Each language entry is a `(baseUrl) => string` factory so the service URL can
 * be populated with the current platform URL (same pattern as the Logging tab).
 */
export const specificAICode = {
    python: (baseUrl) => `from specific_ai import SpecificAIClient


def specific_ai_example():
    """Example of using SpecificAIClient for direct inference on SpecificAI deployed models."""

    example = "This movie was terrible!" # Replace with your own example

    client = SpecificAIClient(
        url="${baseUrl}",  # Your SpecificAI platform URL (or the inference
        #                                endpoint URL if the model is deployed independently
        #                                from the specific ai platform.
        #                                Example: http://35.124.75.132:8000)
        api_key="<your-api-key>",  # Create one under Settings. The SDK falls back to the
        #                            SPECIFIC_AI_API_KEY environment variable when omitted.
        # trace=True,   # Uncomment to enable request tracing for SpecificAI platform
        # inference_url="<your-inference-endpoint-url>",  # Uncomment 'inference_url' only if
        #                                                   the model is deployed
        #                                                   independently from the specific ai
        #                                                   platform and you want to trace
        #                                                   its interactions within the
        #                                                   platform (trace=True).
        #                                                   Example: http://35.124.75.132:8000/public/triton
    )

    # Make a direct inference request to the deployed SpecificAI model
    # The response type depends on your task type (Classification, Entity Extraction, Summarization, etc.)
    response = client.create(
        message=example,
        task_name="<your-task-name>",  # The deployed Task name in the SpecificAI platform
        project_name="<your-project-name>",  # The deployed Project name in the SpecificAI platform
    )

    # And that's it!
    print(f"Response: {response}")


if __name__ == "__main__":
    specific_ai_example()
`,
    typescript: (baseUrl) => `import { SpecificAIClient } from "specific-ai"

// Example of using SpecificAIClient for direct inference on SpecificAI deployed models.

const example = "This movie was great!" // Replace with your own example

const client = new SpecificAIClient({
    URL: "${baseUrl}", // Your SpecificAI platform URL (or the inference
    //                                endpoint URL if the model is deployed independently
    //                                from the specific ai platform.
    //                                Example: http://35.124.75.132:8000)
    apiKey: "<your-api-key>", // Create one under Settings. The SDK falls back to the
    //                           SPECIFIC_AI_API_KEY environment variable when omitted.
    // trace: true,   // Uncomment to enable request tracing for SpecificAI platform
    // inferenceURL: "<your-inference-endpoint-url>",  // Uncomment 'inferenceURL' only if
    //                                                    the model is deployed
    //                                                    independently from the specific ai
    //                                                    platform and you want to trace
    //                                                    its interactions within the
    //                                                    platform (trace=true).
    //                                                    Example: http://35.124.75.132:8000/public/triton
});

// Make a direct inference request to the deployed SpecificAI model
// The response type depends on your task type (Classification, Entity Extraction, Summarization, etc.)
const response = await client.create(example, {
        taskName: "<your-task-name>", // The deployed Task name in the SpecificAI platform
        projectName: "<your-project-name>", // The deployed Project name in the SpecificAI platform
    }
);

// And that's it!
console.log("Response: ", response);
`,
    go: (baseUrl) => `package main

import (
	"context"
	"fmt"
	"log"
	specificai "github.com/marketplace-specificai/go-specific-ai-sdk"
	"github.com/marketplace-specificai/go-specific-ai-sdk/inference"
)

// Example of using the SpecificAI client for direct inference on SpecificAI deployed models.
func main() {
	example := "This movie was terrible!" // Replace with your own example

	client, err := specificai.NewClient(
		specificai.WithBaseURL("${baseUrl}"), // Your SpecificAI platform URL (or the inference
		//                                                   endpoint URL if the model is deployed independently
		//                                                   from the specific ai platform.
		//                                                   Example: http://35.124.75.132:8000)
		specificai.WithAPIKey("<your-api-key>"), // Create one under Settings. The SDK falls back to
		//                                          the SPECIFIC_AI_API_KEY environment variable when omitted.
		// specificai.WithTrace(true),   // Uncomment to enable request tracing for SpecificAI platform
		// specificai.WithInferenceURL("<your-inference-endpoint-url>"),  // Uncomment 'WithInferenceURL' only if
		//                                                                  the model is deployed
		//                                                                  independently from the specific ai
		//                                                                  platform and you want to trace
		//                                                                  its interactions within the
		//                                                                  platform (WithTrace(true)).
		//                                                                  Example: http://35.124.75.132:8000/public/triton
	)
	if err != nil {
		log.Fatal(err)
	}
	defer client.Close()

	// Make a direct inference request to the deployed SpecificAI model
	// The response type depends on your task type (Classification, Entity Extraction, Summarization, etc.)
	response, err := client.Create(
		context.Background(),
		example,
		"<your-task-name>",    // The deployed Task name in the SpecificAI platform
		"<your-project-name>", // The deployed Project name in the SpecificAI platform
	)
	if err != nil {
		log.Fatal(err)
	}

	// And that's it!
	fmt.Printf("Response: %v\\n", response)
}
`
};

